import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, Auth } from 'firebase/auth';

// Firebase will be initialized dynamically when config is loaded
let app: FirebaseApp | null = null;
let auth: Auth | null = null;
let googleProvider: GoogleAuthProvider | null = null;

export const initializeFirebase = (config: any) => {
  if (app) return; // Already initialized

  const firebaseConfig = {
    apiKey: config.FE_FIREBASE_API_KEY,
    authDomain: config.FE_FIREBASE_AUTH_DOMAIN,
    projectId: config.FE_FIREBASE_PROJECT_ID,
    storageBucket: config.FE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: config.FE_FIREBASE_MESSAGING_SENDER_ID,
    appId: config.FE_FIREBASE_APP_ID
  };

  // Only initialize if we have the required config
  if (firebaseConfig.apiKey && firebaseConfig.authDomain && firebaseConfig.projectId) {
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);
    
    googleProvider = new GoogleAuthProvider();
    googleProvider.setCustomParameters({
      prompt: 'select_account'
    });
  }
};

export const getFirebaseAuth = () => {
  if (!auth) {
    throw new Error('Firebase not initialized. Make sure to call initializeFirebase first.');
  }
  return auth;
};

export const getGoogleProvider = () => {
  if (!googleProvider) {
    throw new Error('Firebase not initialized. Make sure to call initializeFirebase first.');
  }
  return googleProvider;
};

export const isFirebaseConfigured = () => {
  return app !== null && auth !== null && googleProvider !== null;
};